"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const segment_1 = __importDefault(require("./segment"));
function trackEvent(handle) {
    return (event, ...extra) => {
        (0, segment_1.default)((analytics) => {
            const type = event.type;
            const element = event.currentTarget;
            const text = element.innerText.trim() || element.title.trim();
            const name = element.name || null;
            const value = element.value || null;
            const href = element.href || null;
            analytics.track(type, {
                text,
                name,
                value,
                href,
                location: location.toString(),
            });
        });
        handle && handle(event, ...extra);
    };
}
exports.default = trackEvent;
